import {Component, OnInit, HostBinding, HostListener, ViewChild, AfterViewInit, OnDestroy} from '@angular/core';
import {DataService} from '../../_services/data.service';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
// import { AuthService } from '../../_services/auth.service';
// import { trigger, state, transition, animate, style } from '@angular/animations';
import {anim, slideRight, slideUp} from 'src/app/animations';
import {Title} from '@angular/platform-browser';
import {FlatPropertiesTestComponent} from '../buildings/flat-properties-test/flat-properties-test.component';
import {Location} from '@angular/common';
import {HowMuchRoomsComponent} from '../buildings/how-much-rooms/how-much-rooms.component';
import {ThreejsComponent} from '../threejs/threejs.component';
import {WindRoseComponent} from '../wind-rose/wind-rose.component';
import {TranslateService} from '@ngx-translate/core';
import {User} from '../../_core/_interface/user';
import {AuthService} from '../../_services/auth.service';
import {closeExplanationF, prevnextF, showCurrentExplanationF} from 'src/app/_core/_function/prevNext';
import {Subscription} from "rxjs";
import { postMessageToIframe } from 'src/app/_core/_function/postMessageToIframe';

// import "@lottiefiles/lottie-player";
@Component({
    selector: 'app-test-project',
    templateUrl: './test-project.component.html',
    styleUrls: ['./test-project.component.scss'],
    animations: [
        slideRight, slideUp
    ],
    host: {
        '[@slideRight]': 'condition'
    }
})

export class TestProjectComponent implements OnInit, OnDestroy {
    // @HostBinding('@anim')
    showComponents: boolean = false;
    currentBuilding: any;
    currentRoomAmount: any;
    flatStatusClass: string;
    desktopResolution: boolean = true;
    showBuilding: boolean = false;
    moveBuildingMenuFull: boolean = false;
    // moveBuildingMenuHalf: boolean = false;
    flat: any;
    showBuildings: boolean = false;
    iframeElement: any;
    removeCloseButton: boolean = false;
    showProject: boolean = true;
    message: any = "";
    withBuilding: boolean = false;
    curSceneName: string = '';
    sceneTitleArray: [] = [];
    activateRose: boolean = true;
    refresh: boolean = true;
    buildingTitle: string = '';
    showIntro: boolean = false;
    urlSwitcher: string = '';
    ifThree: boolean = false;
    closeBuildingPanel: boolean = false;
    fullWidthPropertiesFlatPanel: boolean = false;
    currentFlatsPanelOnClickShow: boolean = false;
    illustrationOnly: boolean = false;
    illustrationOnlyNote: string = "";
    currentPrototype: any;
    showProtoFilter: boolean = false;
    building: any;
    hideRoomNumberProperty: boolean = true;
    showRose: boolean = true;
    buildType: string = "";
    showFloorPlan: boolean = false;
    floorId: string = '';
    company: any;
    currentLanguage: string = 'he';
    // spirikal: string = "";

    // @HostBinding('slideRight')

    @HostListener('@slideRight.done', ['$event']) doneDrawerHandler(event: any): void {
        this.showComponents = true;
    }

    @HostBinding('class.move-building-menu-half') moveBuildingMenuHalf: boolean = false;


    item: any;
    compId: any;
    user: User;
    proj: any;
    projUid: any;
    flagIfListenerOpenFake3dExist: number = 0;
    routeParams = {};
    compositeDesign: boolean = false;
    unika: boolean = false;
    showFlatProperties: boolean = false;
    @ViewChild('cmp')
    childFlatProperties: FlatPropertiesTestComponent;
    compTitle: string = '';
    @ViewChild('howMuchRooms')
    howMuchRoomsChild: HowMuchRoomsComponent;
    @ViewChild('three')
    threeJs: ThreejsComponent;
    @ViewChild('rose')
    rose: WindRoseComponent;
    showFilters: boolean = true;
    private floorIdPlaneSubscription: Subscription;
    private fullWidthPropertiesSubscription: Subscription;
    private currentFlatsPanelSubscription: Subscription;
    private curBuildingSubscription: Subscription;

    constructor(
            public dataService: DataService,
            private route: ActivatedRoute,
            private titleService: Title,
            private router: Router,
            private location: Location,
            public translate: TranslateService,
            private auth: AuthService
    ) {
        this.compId = this.route.snapshot.params.id;
        this.projUid = this.route.snapshot.params.idp;
    }

    @HostBinding('class') get class() {
        if (this.proj) {
            return 'roj' + this.proj[0].title;
        }
    }

    ngOnInit(): void {
        this.urlSwitcher = this.dataService.wichDesign().urlSwitcher;
        this.compositeDesign = this.dataService.wichDesign().compositeDesign;
        this.unika = this.dataService.wichDesign().unika;
        this.user = this.auth.currentUserValue;
        // if(this.route.snapshot.params.compName){
        //   this.dataService.getSpecCompByName('Spirikal').subscribe(comp => {
        //     this.compId = comp[0].id;
        //   })
        //   this.dataService.getItemsByCompId(this.compId).subscribe(items => {
        //     this.projects = items;
        //   });
        // }
        // switch (window.location.host) {
        //   case '                           ':
        //     this.compTitle = 'Get Key 1';
        //     break;
        //   case 's-katorza.com':
        //     this.compTitle = 'S. Katorza';
        //     break;
        //   case 'spirical.net':
        //     this.compTitle = 'Spirikal';
        //     break;
        //   case 'spirical-maps.firebaseapp.com':
        //     this.compTitle = 'Spirikal';
        //     break;
        //   case 'localhost:4200':
        //     this.compTitle = 'Spirikal';
        //     break;
        //   default:
        // }
        this.compTitle = this.dataService.hoisUrlGetTitle();
        ////123**************************
        if (this.route.snapshot.queryParams.lang) {
            this.currentLanguage = this.route.snapshot.queryParams.lang;
        }


        window.addEventListener("message", this.receiveMessage.bind(this), false);
        if (window.innerWidth < 1200) {
            this.desktopResolution = false;
            this.showFilters = false;
        }
        if (this.route.snapshot.queryParams.m === 'all') {
            this.removeCloseButton = true;
        }
        this.isItFlatF();
        this.isItBuildingMobileF()
        this.router.events.subscribe((val) => {
            this.isItFlatF();
            this.isItBuildingMobileF()
        });
        this.routeParams = this.route.snapshot.params;
        // if(this.route.snapshot.params.buid && !this.route.snapshot.params.buid.includes("_")) {
        if (!this.route.snapshot.params.buid && !this.route.snapshot.params.flatId) {
            this.showIntro = true;
        }
        if (this.route.snapshot.params.buid) {
            this.showBuilding = true;
            this.dataService.getSpecBuilding(this.route.snapshot.params.buid).subscribe(building => {
                this.building = building[0];
                this.withBuilding = building[0]?.withBuilding;
                if (this.currentLanguage === 'en') {
                    this.buildingTitle = building[0]?.nameEn;
                } else {
                    this.buildingTitle = building[0]?.name;
                }


                if (this.building.buildType === 'office' || 'housing') {
                    this.showFloorPlan = true;
                    this.floorId = this.building.floors[0].floor.id;
                }
                if (building[0]?.hideRoomNumberProperty === false && building[0]?.hideRoomNumberProperty !== undefined) {
                    this.hideRoomNumberProperty = false;
                } else {
                    this.hideRoomNumberProperty = true;
                }
            });
        }
        // this.compositeDesign = this.dataService.compositeDesign();
        let counter = 0;
        if (counter === 0) {
            // this.route.url.subscribe(segment => {
            //   if (segment.length > 3) {
            //     this.isItFlatF();
            //     for (let i = 0; segment.length > i; i++) {
            //       if (segment[i].path === 'n') {
            //         this.compositeDesign = true;
            //         // const isFlat = this.isItFlatF();
            //       } else if (segment[i].path === 'u') {
            //         this.compositeDesign = true;
            //         this.unika = true;
            //       }
            //     }
            //   }
            // })
            counter++;


        }

        this.dataService.getSpecProject(this.projUid).subscribe(proj => {
            if (proj.length > 0) {
                this.proj = proj;
                // this.spirikal = this.proj[0].spirical;
                if (!this.proj.hideIntro) {
                    this.proj.hideIntro = false;
                }
                this.illustrationOnly = proj[0].illustrationOnly;
                this.illustrationOnlyNote = proj[0].illustrationOnlyNote;
                this.titleService.setTitle(this.compTitle + '-' + this.proj[0].companyTitle + ' - ' + this.proj[0].title);
                // this.titleService.setTitle('spirikal' + ' - ' + this.proj[0].title);
                if (this.proj[0].public === false) {
                    this.showProject = false;
                }
            }


            // get first building to composite design if no building Id in url
            if (this.route.snapshot.params.buid === undefined && this.compositeDesign) {
                // if (this.desktopResolution) {
                //   this.dataService.getItemsByProjId(this.proj[0].id).subscribe(buildList => {
                //     let path;
                //     buildList = buildList.filter(building => building.withBuilding === true);
                //     if (buildList.length > 0) {
                //       path = '/company/n/' + this.compId + '/' + this.projUid + '/building/' + buildList[0].uid;
                //       // this.reloadCurrentRoute(path);
                //     }
                //     else {
                //       // path = '/company/n/' + this.compId + '/' + this.projUid;
                //       // window.location.reload();
                //       // this.reloadCurrentRoute(path);
                //     }
                //   });
                // }
                this.showBuilding = false;
            }

            this.fullWidthPropertiesSubscription = this.dataService.fullWidthPropertiesFlatPanel.subscribe(item => {
                this.fullWidthPropertiesFlatPanel = item;
            })
            this.currentFlatsPanelSubscription = this.dataService.currentFlatsPanelOnClickShow.subscribe(item => {
                this.currentFlatsPanelOnClickShow = item;
            })
        });


        this.floorIdPlaneSubscription = this.dataService.floorIdPlane.subscribe(floorId => {
            this.showFloorPlan = true;
            this.floorId = floorId;
        })


        if (this.desktopResolution) {
            this.location.onUrlChange(path => {
                const pathname = path.split('/');
                if (pathname.length === 8 && this.childFlatProperties) {
                    this.showFlatProperties = true;
                    this.childFlatProperties.flatId = pathname[7]
                    this.childFlatProperties.projUid = this.route.snapshot.params.buid
                    this.childFlatProperties.ngOnInit();
                }
            })
        }
        this.curBuildingSubscription = this.dataService.curBuilding.subscribe(item => {
            if (item) {
                this.buildingTitle = item.name;
                if (this.currentLanguage === 'en') {
                    this.buildingTitle = item?.nameEn;
                } else {
                    this.buildingTitle = item?.name;
                }
                this.floorId = item.floors[0].floor.id
                this.floorId = item.floors[0].floor.id
                console.log(this.buildingTitle);
                this.resetFilters();
                if (item.hideRoomNumberProperty === false && item.hideRoomNumberProperty !== undefined) {
                    this.hideRoomNumberProperty = false;
                } else {
                    this.hideRoomNumberProperty = true;
                }

            }
        })

        //remove animation SPIRIKAL INTRO after complete
        setTimeout(function () {
            let lottie = document.getElementById('intro');

            if (lottie) {
                lottie.addEventListener('complete', function () {
                    console.log('complete animation with lottie animation intro');
                    this.showIntro = !this.showIntro;
                    lottie.remove();
                })
            }
        }, 2000);
    }

    showRoseWind(inOut) {
        let rose = document.getElementById('roseWind');
        if (rose) {
            if (inOut === 'out') {
                rose.classList.remove('active');
                return;
            }
            rose.classList.add('active');
        }
    }

    closeExplanation() {
        closeExplanationF();
    }

    showCurrentExplanation(event) {
        showCurrentExplanationF(event);
    }

    prevnextF(event, direction) {
        prevnextF(event, direction);
    };

    closeFloorDrawing() {
        this.showFloorPlan = false;
    }

    togglePanel() {
        this.closeBuildingPanel = !this.closeBuildingPanel;
        if (!this.closeBuildingPanel) {
            this.dataService.savecurrentFlatsPanelOnClickShow(false);
        }
    }

    activateRoseF() {
        this.activateRose = false;
        setTimeout(() => {
            //  this.rose.activateRoseF();
            this.activateRose = true;
        }, 500);
    }

    goToNewVersion() {
        this.router.navigate(['/company/u/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp")]).then(() => {
            window.location.reload();
        });
    }

    closeFlatProperties(event) {
        this.showFlatProperties = false;
        // const url = '/company/n/' + this.route.snapshot.paramMap.get('id') + '/' + this.route.snapshot.paramMap.get('idp') + '/building/' + this.route.snapshot.paramMap.get('buid');

        // this.router.createUrlTree([], {relativeTo: flat.id, queryParams: {param: 6}}).toString()
        // this.location.go(url);
        // this.router.navigate(['/company/n/' + this.route.snapshot.paramMap.get('id') + '/' + this.route.snapshot.paramMap.get('idp') + '/building/' + this.route.snapshot.paramMap.get('buid')]);

        this.router.navigate([this.urlSwitcher + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + '/building/' + this.route.snapshot.paramMap.get("buid")]);

        // if (this.compositeDesign && !this.unika) {
        //   this.router.navigate(['/company/n/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + '/building/' + this.route.snapshot.paramMap.get("buid")]);
        // }  else if (this.unika) {
        //   this.router.navigate(['/company/u/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + '/building/' + this.route.snapshot.paramMap.get("buid")]);
        // }
    }


    reloadCurrentRoute(path) {
        let currentUrl = path;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
    }

    // hideBuildingMenu() {
    //   this.moveBuildingMenuHalf = true;
    // }
    moveBuildinMenuFalse(size) {
        if (size === 'full') {
        } else {
            this.moveBuildingMenuHalf = false;
        }
    }

    moveBuildinMenu(size) {
        if (!this.unika) {
            if (size === 'full') {
                this.moveBuildingMenuFull = !this.moveBuildingMenuFull;
            } else {
                if (!this.moveBuildingMenuHalf) {
                    setTimeout(() => {
                        this.moveBuildingMenuHalf = true;
                    }, 2250);
                }
            }
        }
    }

    isItFlatF() {
        if (this.route.snapshot.params.flatId) {
            this.showFlatProperties = true;
        } else {
            this.showFlatProperties = false;
        }
    }

    isItBuildingMobileF() {
        if (!this.desktopResolution) {
            if (this.route.snapshot.params.buid) {
                this.showBuildings = true;
            } else {
                this.showBuildings = false;
                this.showBuilding = false;
            }
        } else {
            this.showBuildings = false;
        }
    }

    currentRoomAmountF($event) {
        this.dataService.saveNumRoomsFilter($event);
        this.currentRoomAmount = $event;
    }

    currentFlatPrototypeF($event) {
        this.dataService.savePrototypeFilter($event);
        this.currentPrototype = $event;
    }

    flatStatusClassF($event) {
        this.flatStatusClass = $event;
        this.dataService.saveFlatStatusClass($event);
    }

    floorsNumbersF($event) {
        // this.dataService.saveFloorsNumbers($event);
    }

    currentBuildingF($event) {
        if (this.threeJs) {
            this.threeJs.reset(event);
            this.threeJs.setBuildingZoom();
        }
        if ($event.glb) {
            this.ifThree = true;
            this.dataService.saveifThree(this.ifThree);
        } else {
            this.ifThree = false;
            this.dataService.saveifThree(this.ifThree);
        }
        this.currentBuilding = $event;
        this.buildType = this.currentBuilding.buildType;
        if (this.currentBuilding.allPrototypesArray && this.currentBuilding.showFilterProto) {
            this.showProtoFilter = true;
        }
        this.closeBuildingPanel = false;
        this.dataService.curBuilding.subscribe(item => {
            this.currentBuilding = item;
            // if(this.currentBuilding.buildSpirikal){
            //   if(this.currentBuilding.buildSpirikal !== this.spirikal) {
            //     this.spirikal = this.currentBuilding.buildSpirikal;
            //   }
            // }
        })
        this.ifThree;
        // this.howMuchRoomsChild.ngOnInit();
    }

    resetFilters() {
        // this.dataService.curBuilding.subscribe(item => {
        //   this.currentBuilding = item;
        // })

        this.refresh = false;
        setTimeout(() => {
            this.refresh = true;
        }, 1);
    }

    projPassFromMenu(proj) {
        this.proj = proj;
    }

    openFake3d() {
        let fake3dGallery = document.getElementsByClassName('slogan-img-project-right-down')[0];
        let addBlurElement = document.getElementsByClassName('da-iframe')[0];
        if (fake3dGallery) {
            let htmls = fake3dGallery.getElementsByClassName('htmls')[0];
            let flagIfListenerExist = 0;
            htmls.addEventListener("click", function () {
                fake3d.className += ' active';
                addBlurElement.classList.add('to-blur');
            });
            let fake3d = fake3dGallery.getElementsByClassName('iframes')[0];
            let elChild = document.createElement('a');
            fake3d.prepend(elChild);
            elChild.setAttribute('class', 'pClose 3delement-close active');
            elChild.addEventListener("click", function () {
                fake3d.classList.remove('active');
                addBlurElement.classList.remove('to-blur');
            });
            if (this.flagIfListenerOpenFake3dExist == 0) {
                fake3d.className += ' active';
                addBlurElement.classList.add('to-blur');
            }
        }
        ++this.flagIfListenerOpenFake3dExist;
    }


    receiveMessage(event) {
        this.message = event.data;
        console.log(this.message);
        let ifUrl: boolean = false;
        if (typeof (this.message) !== 'object') {
            if (this.message.includes("https://") && ((this.message.includes("!_{") < 0) || !this.message.includes("!_{"))) {
                ifUrl = true;
            }
        }
        if (this.route.snapshot.queryParams.m !== 'n' && this.route.snapshot.queryParams.m !== 'buildings' && ifUrl) {
            this.showLinkToBuilding();
        }
        if (this.message.length > 0 && !this.message.includes("_") && typeof (this.message) !== 'object' && !ifUrl) {
            this.dataService.getSpecBuilding(this.message).subscribe(building => {
                this.buildingTitle = building[0]?.name;
            })
            // if (this.compositeDesign && !this.unika) {
            //
            //   this.router.navigate(['/company/n/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + '/building/']);
            //
            // } else
            if (this.unika) {
                if (this.message.indexOf("?m=buildings") > -1) {
                    let result = this.message.replace('?m=buildings', "");
                    this.router.navigate(['/company/u/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + '/building/' + result], {queryParams: {m: 'buildings'}});
                } else {
                    let path = this.message;
                    let queryParams = {};

                    if (this.message.includes('?')) {
                        const parts = this.message.split('?'); // Split into path and query string
                        path = parts[0]; // The part before the `?`
                        const queryString = parts[1]; // The part after the `?`

                        // Convert query string into key-value pairs
                        queryParams = queryString.split('&').reduce((acc, pair) => {
                            const [key, value] = pair.split('=');
                            acc[key] = value;
                            return acc;
                        }, {});
                        this.router.navigate(['/company/u/' +
                        this.route.snapshot.paramMap.get("id") + '/' +
                        this.route.snapshot.paramMap.get("idp") +
                        '/building/' +
                        path
                        ], {queryParams});
                    } else {
                        this.router.navigate(['/company/u/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + '/building/' + this.message]);
                    }
                }
            }
        }
        if (ifUrl) {
            window.open(this.message, '_self');
            return;
        } else if (typeof (this.message) === 'string') {
            if (this.message.includes("scene_")) {
                this.curSceneName = this.message;
            }
        } else if (typeof (this.message) === 'object') {
            console.log(this.message);

            if (!this.areArraysEqualShallow(this.sceneTitleArray, this.message)) {
                this.showRose = false;
                this.sceneTitleArray = [];
            }


            setTimeout(() => {
                this.showRose = true;
                this.sceneTitleArray = this.message;
            });
        }
    }

    areArraysEqualShallow(arr1, arr2) {
        // Check if the arrays are the same length
        if (arr1.length !== arr2.length) {
            return false;
        }

        // Check each element in the arrays
        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) {
                return false; // Found elements that are not the same
            }
        }

        // If we reached this point, all elements are the same
        return true;
    }

    showLinkToBuilding() {

        // this.closeViewFloors();

        // const data = {
        //   hotspotName: flat.hotspotName,
        //   flatName: this.buildingName + "_" + flat.number,
        //   flatStatus: flat.status,
        //   flatFloor: flat.floorNumber,
        //   singleFlat: 'false  '
        // };


        // const data = hotspotName;
        // Set url to be sure that the message will be sent to only this url
        // Full url to iframe
        // const url = 'https://topeye.club/';
        // //  Access iframe by name
        // // const win = window.frames.tourIframe;
        // const test = document.getElementsByClassName("da-iframe");
        // let test1: HTMLIFrameElement;
        // if (test.length > 0) {
        //     test1 = test[0].getElementsByTagName('iframe')[0];
        // }
        // const win = test1;

        // if (win) {
        //     this.iframeElement = eval("(win.contentWindow || win.contentDocument)");
        //     this.iframeElement.postMessage(JSON.stringify('showLink'), url);
        // }

        postMessageToIframe('showLink');


    }

    ngOnDestroy() {
        this.floorIdPlaneSubscription && this.floorIdPlaneSubscription.unsubscribe();
        this.fullWidthPropertiesSubscription && this.fullWidthPropertiesSubscription.unsubscribe();
        this.currentFlatsPanelSubscription && this.currentFlatsPanelSubscription.unsubscribe();
        this.curBuildingSubscription && this.curBuildingSubscription.unsubscribe();
    }

}
